import { Navigate } from 'react-router-dom'
import { ROUTES } from '@common'
import { membershipServices } from '@services'

/**
 * MembershipRedirect component
 * Redirects users to root page if they have accessToken in localStorage
 * This prevents authenticated users from accessing membership auth pages
 */
export default function MembershipRedirect({ children }) {
    const tokens = membershipServices.getTokens()

    // If user has accessToken, redirect to root page
    if (tokens.accessToken) {
        return <Navigate to={ROUTES.root} replace />
    }

    // If no accessToken, render the membership pages
    return children
}
